import Actions from '../actions/actions';
import { EnvState } from '../interfaces/env';

const initialState: EnvState = {
  appContext: undefined,
  fbAppId: '',
  fbPageId: '',
  gaTrackingId: '',
  botWidget: null,
  globalJavascriptBaseUrl: '',
  recurlySubdomain: '',
  notificationBanners: [],
  sysVariablesAllowedToAssign: {
    facebook: [],
    sms: [],
    webChat: [],
    instagram: [],
  },
  userCountry: null,
  webchatHost: '',
  daysForIndefinitelyAway: 0,
};

export default function env(state = initialState, action) {
  switch (action.type) {
    case Actions.SET_ENV: {
      return action.payload;
    }
    default:
      return state;
  }
}
